<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Delete" class="d-icon d-icon--delete" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.147 2.147A.5.5 0 0 1 4.5 2H10a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 10H4.5a.5.5 0 0 1-.353-.146l-3.5-3.5a.5.5 0 0 1 0-.707l3.5-3.5Zm.56.853-3 3 3 3H10a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 3H4.707Z"/><path d="M9.354 4.147a.5.5 0 0 1 0 .707L8.207 6l1.147 1.147a.5.5 0 0 1-.707.707L7.5 6.707 6.354 7.854a.5.5 0 0 1-.707-.707L6.793 6 5.647 4.854a.5.5 0 0 1 .707-.707L7.5 5.293l1.147-1.146a.5.5 0 0 1 .707 0Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDelete',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
